import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center py-4 sm:py-8 sm:p-8 bg-zinc-900" }
const _hoisted_2 = { class: "w-full max-w-md relative rounded-2xl bg-zinc-800/50 p-8 transition-all duration-300" }
const _hoisted_3 = { class: "relative z-10" }
const _hoisted_4 = { class: "mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-zinc-700/50" }

import { ClockIcon } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginExpired',
  setup(__props) {

const redirectToLogin = () => {
  // Replace with your actual login route
  if (window.top) window.top.location.href = 'https://dashboard.hoopay.com.br/login.html'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ClockIcon), { class: "h-10 w-10 text-blue-400" })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "mb-3 text-center text-2xl font-bold text-white" }, "Sessão Expirada", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-8 text-center text-zinc-400" }, " Sua sessão expirou por inatividade. Por favor, faça login novamente para continuar utilizando o Bot Express. ", -1)),
        _createElementVNode("button", {
          onClick: redirectToLogin,
          class: "w-full rounded-xl bg-emerald-500 py-3 px-4 text-center font-semibold text-black transition-colors hover:bg-emerald-400"
        }, " Fazer Login "),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mt-6 text-center" }, [
          _createElementVNode("a", {
            href: "https://wa.me/5561996213140",
            class: "text-sm text-zinc-400 hover:text-zinc-300 transition-colors"
          }, " Precisa de ajuda? Entre em contato com o suporte ")
        ], -1))
      ])
    ])
  ]))
}
}

})